var styles = {
  "Combo": "Online-Store-UI-Combo_1xb6w",
  "readOnly": "Online-Store-UI-Combo--readOnly_1fzmx",
  "focused": "Online-Store-UI-Combo--focused_wpv3q",
  "withHeader": "Online-Store-UI-Combo--withHeader_1qcx9",
  "withFooter": "Online-Store-UI-Combo--withFooter_mqkyz",
  "ToolbarWrapper": "Online-Store-UI-Combo__ToolbarWrapper_gffmy",
  "unframed": "Online-Store-UI-Combo--unframed_x6k50",
  "toneMagic": "Online-Store-UI-Combo--toneMagic_fb9tj",
  "Children": "Online-Store-UI-Combo__Children_1v066",
  "SlateWrapper": "Online-Store-UI-Combo__SlateWrapper_waupg",
  "Slate": "Online-Store-UI-Combo__Slate_1x13m",
  "compact": "Online-Store-UI-Combo--compact_1gvpc",
  "fullWidth": "Online-Store-UI-Combo--fullWidth_1sogd",
  "fixedWidth": "Online-Store-UI-Combo--fixedWidth_3c0sw"
};

export { styles as default };
